export default "__VITE_ASSET__BOoUMuf8__"